const constants = {
  oneDay: 24 * 60 * 60 * 1000,
};

export default constants;
